import React, {Component, Fragment} from 'react';
import Select, {components} from 'react-select';
import SelectBase from "./components/global/SelectBase";
import {Dropdown} from 'react-bootstrap';
import DropdownToggle from "./components/global/DropdownToggle";
import Menu from "./components/select-filter/Menu";
import MenuList from "./components/select-filter/MenuList";
import OptionItem from "./components/select-filter/OptionItem";
import SingleValue from "./components/select-filter/SingleValue";
import SelectContainer from "./components/select-search/SelectContainer";
import DropdownIndicator from "./components/select-search/DropdownIndicator";
import '../../../assets/sass/components/react-select.scss';

// TODO: Merge with SelectSearch

class SelectSearch extends SelectBase {

    filterSearchBtn = React.createRef();
    filterSearchMenu = React.createRef();

    static defaultProps = {
        searchProps: {}
    }

    constructor(props) {
        super(props)
    
        this.state = {
             selectedValue: props.placeholder
        }
    }
    

    setMenuHeight = () => {

        if(this.filterSearchMenu.current) {

            var menuListPos, dropdownPos;

            this.filterSearchMenu.current.style.setProperty("height", `60px`, "important");

            if(this.filterSearchMenu.current) dropdownPos = this.filterSearchMenu.current.getBoundingClientRect();
            if(this.select.current) menuListPos = this.select.current?.select?.menuListRef?.closest('.filter-wrapper').getBoundingClientRect();

            var height = menuListPos && dropdownPos ? menuListPos?.height + dropdownPos?.height : 0;

            this.filterSearchMenu.current.style.setProperty("height", `${height}px`, "important");
        }
    }

    componentDidUpdate(prevProps) {
        var $this = this;

        // this.setMenuHeight();

        if(this.props.menuPosition) {
            setTimeout(function () {
                var select = $this.filterSearchBtn.current;
                var menu = $this.filterSearchMenu.current;
                $this.setMenuPosition(select,menu)
            },1)
        }
    }

    dropDownToggle = (toggle) => {
        if(toggle) {
            this.onMenuOpen();
        } else {
            this.onMenuClose();
        }

        this.setState({ toggle });
    }

    onCheckChange = option => {
        this.props.onChange(option);
        this.setState({ selectedValue: option?.label });
        this.dropDownToggle(false);
        this.filterSearchBtn.current.classList.add('is-focused')
        this.filterSearchMenu.current.classList.remove('show')
    }

    render() {
        const { menuIsOpen, selectedValue } = this.state;

        return (
            <Fragment>
                <Dropdown className={this.setClasses(this.props, 'filter-items filter-search')} onToggle={this.dropDownToggle}>
                    {/*replace DropdownButton*/}
                    <Dropdown.Toggle ref={this.filterSearchBtn} drop="up" as={DropdownToggle} toggle={this.state.toggle}>
                        {selectedValue ? selectedValue : 'Select ...' }
                    </Dropdown.Toggle>
                    <Dropdown.Menu ref={this.filterSearchMenu} className={['react-select-dropdown-menu react-select-filter-menu react-select-filter-items-menu', this.arrowAutoPlacement(this.state.menuPlacement, this.state.placement)].join(' ')} show={this.state.toggle}>
                        <Select
                            {...this.props.searchProps}
                            ref={this.select}
                            type={this.props.type}
                            name={this.props.name}
                            classNamePrefix="react-select"
                            placeholder={this.props.searchPlaceholder}
                            // defaultValue={this.state.inOptions[0]}
                            options={this.state.inOptions}
                            // filterOption={this.filterOptions}
                            components={{
                                Menu,
                                MenuList,
                                Option: OptionItem,
                                DropdownIndicator,
                                SingleValue,
                                SelectContainer,
                                IndicatorSeparator: () => null
                            }}
                            filterButtons={this.filterButtons}
                            isAllChecked={this.state.isAllChecked}
                            onCheckChange={this.onCheckChange}
                            onDoneClick={this.onDoneClick}
                            menuPlacement="bottom"
                            //
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            isClearable={false}
                            tabSelectsValue={false}
                            maxMenuHeight="auto"
                            autoFocus
                            menuIsOpen={menuIsOpen}
                        />
                    </Dropdown.Menu>
                </Dropdown>
            </Fragment>
        );
    }
}

export default SelectSearch;
